/**
 * This file was generated
 * Do not edit directly
 * See 'fusion-design-system/build-style-dictionary.js' for more info
 */

export const spaceUtilityVariants = (
    spaceUtilityKey:
        | "m"
        | "mx"
        | "my"
        | "mt"
        | "mr"
        | "mb"
        | "ml"
        | "p"
        | "px"
        | "py"
        | "pt"
        | "pr"
        | "pb"
        | "pl"
        | "gap"
) => ({
    "auto": `sui-u-${spaceUtilityKey}-auto`,
    // prettier-ignore
    "0": `sui-u-${spaceUtilityKey}-0`,
    "0-25x": `sui-u-${spaceUtilityKey}-0-25x`,
    "0-5x": `sui-u-${spaceUtilityKey}-0-5x`,
    "0-75x": `sui-u-${spaceUtilityKey}-0-75x`,
    "1x": `sui-u-${spaceUtilityKey}-1x`,
    "1-25x": `sui-u-${spaceUtilityKey}-1-25x`,
    "1-5x": `sui-u-${spaceUtilityKey}-1-5x`,
    "2x": `sui-u-${spaceUtilityKey}-2x`,
    "2-5x": `sui-u-${spaceUtilityKey}-2-5x`,
    "3x": `sui-u-${spaceUtilityKey}-3x`,
    "4x": `sui-u-${spaceUtilityKey}-4x`,
    "5x": `sui-u-${spaceUtilityKey}-5x`,
    "6x": `sui-u-${spaceUtilityKey}-6x`,
    "7x": `sui-u-${spaceUtilityKey}-7x`,
    "8x": `sui-u-${spaceUtilityKey}-8x`,
    "9x": `sui-u-${spaceUtilityKey}-9x`,
    "10x": `sui-u-${spaceUtilityKey}-10x`,
    "11x": `sui-u-${spaceUtilityKey}-11x`,
    "12x": `sui-u-${spaceUtilityKey}-12x`,
    "negative-0-25x": `sui-u-${spaceUtilityKey}-negative-0-25x`,
    "negative-0-5x": `sui-u-${spaceUtilityKey}-negative-0-5x`,
    "negative-0-75x": `sui-u-${spaceUtilityKey}-negative-0-75x`,
    "negative-1x": `sui-u-${spaceUtilityKey}-negative-1x`,
    "negative-1-25x": `sui-u-${spaceUtilityKey}-negative-1-25x`,
    "negative-1-5x": `sui-u-${spaceUtilityKey}-negative-1-5x`,
    "negative-2x": `sui-u-${spaceUtilityKey}-negative-2x`,
    "negative-2-5x": `sui-u-${spaceUtilityKey}-negative-2-5x`,
    "negative-3x": `sui-u-${spaceUtilityKey}-negative-3x`,
    "negative-4x": `sui-u-${spaceUtilityKey}-negative-4x`,
    "negative-5x": `sui-u-${spaceUtilityKey}-negative-5x`,
    "negative-6x": `sui-u-${spaceUtilityKey}-negative-6x`,
    "negative-7x": `sui-u-${spaceUtilityKey}-negative-7x`,
    "negative-8x": `sui-u-${spaceUtilityKey}-negative-8x`,
    "negative-9x": `sui-u-${spaceUtilityKey}-negative-9x`,
    "negative-10x": `sui-u-${spaceUtilityKey}-negative-10x`,
    "negative-11x": `sui-u-${spaceUtilityKey}-negative-11x`,
    "negative-12x": `sui-u-${spaceUtilityKey}-negative-12x`,
});
